/* eslint-disable no-undef */
import PropTypes from 'prop-types';

function getFileExtension(path) {
  return path.match(/\.([a-z]+)$/i)[1];
}

/**
 * Image optimization component.
 *
 * First will try to use webp format and fallback if the browser doesn't
 * support it.
 *
 * @param {object} props
 */
function Picture({ className, path, alt, lazyLoad = true }) {
  const fileExtension = getFileExtension(path);

  return (
    <picture>
      <source srcSet={require(`public/media/${path}?webp`)} type="image/webp" />
      <source
        srcSet={require(`public/media/${path}`)}
        type={`public/media/${fileExtension}`}
      />
      <img
        alt={alt}
        loading={lazyLoad ? 'lazy' : undefined}
        src={require(`public/media/${path}`)}
        className={className}
      />
    </picture>
  );
}

Picture.propTypes = {
  /**
   * Path is relative to `public/media/`.
   *
   * Has to be that in order for `require` to work properly using
   * the plugin `next-optimized-images` (see next.config.js)
   */
  path: PropTypes.string.isRequired,
  /** Alternative text for the image */
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  /** Lazy load the picture when its being scrolled to */
  lazyLoad: PropTypes.bool,
};

export default Picture;
